import { render, staticRenderFns } from "./MenuCurrency.vue?vue&type=template&id=0b7cadd0"
import script from "./MenuCurrency.vue?vue&type=script&lang=js"
export * from "./MenuCurrency.vue?vue&type=script&lang=js"
import style0 from "./MenuCurrency.vue?vue&type=style&index=0&id=0b7cadd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports